import type {
  CreationWithTask,
  TaskInfo,
  TypesVideoResource,
  ViduV1ExtendSourceCreations,
  ViduV1MediaAsset,
  ViduV1Work,
} from '@/app/types';

/**
 * 合并创作和任务
 * @param creation 创作
 * @param task 任务
 * @returns 合并后的创作和任务
 */
export const mergeCreationAndTask = ({
  creation,
  task,
  creationId,
  extendSourceCreations,
}: {
  creation?: TypesVideoResource;
  task?: TaskInfo;
  creationId?: string;
  extendSourceCreations?: ViduV1ExtendSourceCreations[];
}): CreationWithTask => {
  return {
    ...creation, //todo 这个应该是全的，下边那个貌似一直都是空的
    ...(task?.creations?.[0] || {}),
    id: creationId,
    uri: creation?.uri || '',
    cover_uri: creation?.cover_uri || '',
    task: task,
    extendSourceCreations,
  } as CreationWithTask;
};

export const mergeInspirationInfoAndTaskInfo = (
  inspirationInfo: ViduV1MediaAsset,
  task?: TaskInfo,
): ViduV1MediaAsset => {
  const { creation, ...rest } = inspirationInfo || {};
  const { size, cover_uri, uri } = creation || {};
  return {
    ...rest,
    creation: {
      ...task?.creations?.[0],
      size,
      cover_uri,
      uri,
    },
  };
};
export const mergeActivityInspirationInfoAndTaskInfo = (
  inspirationInfo: ViduV1Work,
  task?: TaskInfo,
): ViduV1MediaAsset => {
  const { creation, ...rest } = inspirationInfo || {};
  const { size, cover_uri = '', uri = '' } = creation || {};
  return {
    ...rest,
    creation: {
      ...task?.creations?.[0],
      size,
      cover_uri,
      uri,
    },
  } as ViduV1MediaAsset;
};
